module.exports = __webpack_public_path__ + "img/4863b73b5ddbac6a7180442b5d2c28f4.png";